export default function Footer() {
  return (
    <footer className="siteFooter">
      <div className="siteFooterInner">
        <div>Gród Kerin</div>
        <div>Witamy na stronie</div>
      </div>
    </footer>
  );
}